import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfileCostsHistory } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeCost(request: Boundaries["removeCost"]["request"]): void;
}

function useRemoveCost(cost: CostProfileCostsHistory[number]): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveCostRequestPending(cost),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveCostRequestSuccess(cost),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveCostRequestFailure(cost),
    ),
    removeCost: core.removeCost,
  };
}

export { useRemoveCost };
